// extracted by mini-css-extract-plugin
export var button = "RegisterViaZoomButton-module--button--e9824";
export var icon = "RegisterViaZoomButton-module--icon--ca4f2";